import { AxiosInstance } from "axios";

export const LuckyDrawService = (axiosInstance: AxiosInstance) => {
  const urlBaseApiLucky = "api/lucky";
  const urlBaseApiUser = "api/useroflucky";
  const urlBaseApiWinder = "api/lucky-winner";
  const urlBaseApiUserOfLucky = "api/useroflucky";
  const urlBaseApiLuckyStart = "api/luck-start";

  return {
    findRandomLucky: async (agendaid?: string) => {
      return await axiosInstance
        .get(`${urlBaseApiUserOfLucky}/randomlucky/${agendaid}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    findAll: async () => {
      return await axiosInstance
        .get(`${urlBaseApiLucky}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    findWinnerById: async (id?: string) => {
      return await axiosInstance
        .get(`${urlBaseApiWinder}/userwinner/${id}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    createLuckeyWinner: async (listUsersId: number, luckyId: string, userofluckyId: number) => {
      return await axiosInstance
        .post(`${urlBaseApiWinder}`, { userofluckyId: userofluckyId, listUsersId: listUsersId, luckyId: Number(luckyId) })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    findById: async (id?: string) => {
      return await axiosInstance
        .get(`${urlBaseApiLuckyStart}/${id}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    updateById: async (id: string, status: boolean) => {
      return await axiosInstance
        .patch(`${urlBaseApiLuckyStart}/${id}`, { status: status })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
  };
};
